<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	import ThermoTempFavPositions from 'src/components/Drawer/ThermostatDrawer/ThermoTempFavPositions.svelte';

	export let id: string;

	// Accept unused props forwarded from parent without Svelte warnings
	export let units;
	export let thermostatDefTemp;
	export let type;
	export let actuators;
	export let deviceSensorId;
	export let deviceSensor;
	export let deviceSensorIsOnline;
	export let extTempSensor;
	export let extTempSensorValue;
</script>

<SidepanelContent>
	<ThermoTempFavPositions {id} />
</SidepanelContent>
